export default {
	'putaway-task': {
		id: 'putaway-task',
		label: '上架任务',
		code: '0003_0005'
	}
}
